import { Col, Row } from 'reactstrap';
import { useLoanRequest } from '../../../Hooks/LoanRequest/useLoanRequest';

export const LoanRequestInfo = () => {
   const loanRequest = useLoanRequest();

   return (
      <Col xl={6} sm={12}>
         <h5 className="mb-4">Información del Préstamo</h5>
         <Row className="gy-2 p-4">
            <Col
               md={12}
               className="d-flex justify-content-between border-bottom pb-2"
            >
               <span className="">Quota:</span>
               <span className="fw-bold">
                  {isNaN(loanRequest.totalQuota)
                     ? '0,00'
                     : loanRequest.totalQuota.toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                       })}
               </span>
            </Col>
            <Col
               md={12}
               className="d-flex justify-content-between border-bottom pb-2"
            >
               <span className="">Valor solicitado:</span>
               <span className="fw-bold">
                  {Number(loanRequest.RequestedCredit).toLocaleString('es-ES', {
                     minimumFractionDigits: 2,
                     maximumFractionDigits: 2,
                  })}
               </span>
            </Col>
            <Col
               md={12}
               className="d-flex justify-content-between border-bottom pb-2"
            >
               <span className="">Inversion propia:</span>
               <span className="fw-bold">
                  {isNaN(Number(loanRequest.selector.form.value))
                     ? '0'
                     : (
                          Number(loanRequest.selector.form.value) * 0.05
                       ).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                       })}
               </span>
            </Col>
            <Col
               md={12}
               className="d-flex justify-content-between border-bottom pb-2"
            >
               <span className="">Seguro:</span>
               <span className="fw-bold">
                  {loanRequest.totalInsurance.toLocaleString('es-ES', {
                     minimumFractionDigits: 2,
                     maximumFractionDigits: 2,
                  })}
               </span>
            </Col>
            <Col
               md={12}
               className="d-flex justify-content-between border-bottom pb-2"
            >
               <span className="">Comisión:</span>
               <span className="fw-bold">
                  {loanRequest.totalCommission.toLocaleString('es-ES', {
                     minimumFractionDigits: 2,
                     maximumFractionDigits: 2,
                  })}
               </span>
            </Col>
            <Col
               md={12}
               className="d-flex justify-content-between border-bottom pb-2"
            >
               <span className="">Tasa periodo:</span>
               <span className="fw-bold">
                  {(loanRequest.periodRate * 100).toLocaleString('es-ES', {
                     minimumFractionDigits: 2,
                     maximumFractionDigits: 2,
                  })}
                  %
               </span>
            </Col>
            <Col
               md={12}
               className="d-flex justify-content-between border-bottom pb-2"
            >
               <span className="">Tasa mensual:</span>
               <span className="fw-bold">
                  {(loanRequest.MonthlyRate * 100).toLocaleString('es-ES', {
                     minimumFractionDigits: 2,
                     maximumFractionDigits: 2,
                  })}
                  %
               </span>
            </Col>
            <Col
               md={12}
               className="d-flex justify-content-between border-bottom pb-2"
            >
               <span className="">Intereses:</span>
               <span className="fw-bold">
                  {isNaN(Number(loanRequest.selector.form.value))
                     ? '0,00'
                     : (
                          Number(loanRequest.selector.form.value) *
                          loanRequest.periodRate
                       ).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                       })}
               </span>
            </Col>
            <Col
               md={12}
               className="d-flex justify-content-between border-bottom pb-2"
            >
               <span className="">Valor total a pagar:</span>
               <span className="fw-bold">
                  {isNaN(
                     Number(loanRequest.totalQuota) *
                        Number(loanRequest.selector.form.period)
                  )
                     ? '0,00'
                     : (
                          Number(loanRequest.totalQuota) *
                          Number(loanRequest.selector.form.period)
                       ).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                       })}
               </span>
            </Col>
         </Row>
      </Col>
   );
};
